/**
 * Constantes estructurales del negocio.
 *
 * Aca van unicamente los invariantes que NO cambian sin cambiar el sistema: la zona
 * horaria, la moneda, el tamano de la rejilla. Todo lo que el propietario puede ajustar
 * —tarifas, ventana publica, horas de cancelacion, multas— es configuracion versionada
 * en Firestore (ADR-012), NO constantes de este archivo.
 */
/**
 * Identificador IANA de la zona del negocio. Toda decision de negocio se toma aca
 * (ADR-006). Prohibido el desfase fijo "-03:00": Uruguay no aplica horario de verano
 * desde 2015, pero si lo aplico antes y una regla puede volver a cambiar.
 */
export const ZONA_HORARIA_NEGOCIO = 'America/Montevideo';
/** Tope histórico para leer conceptos de operaciones anteriores a ADR-070. */
export const MAXIMO_LARGO_CONCEPTO_OPERACION = 160;
/** Familias cerradas para las compras y ventas simples (ADR-070). */
export const FAMILIAS_OPERACION = ['snacks', 'bebidas', 'paletasAccesorios'];
/** Monedas nominales admitidas en compras y ventas simples (ADR-070). */
export const MONEDAS_OPERACION = ['UYU', 'USD'];
/** Unidad física en la que se descuenta el inventario de Paletas y Accesorios. */
export const UNIDADES_STOCK_PRODUCTO = ['unidad', 'tubo'];
/** Presentación en la que el proveedor entrega mercadería. */
export const PRESENTACIONES_COMPRA_PRODUCTO = ['unidad', 'caja', 'exhibidor'];
/** Tope del proveedor escrito a mano en una compra libre. */
export const MAXIMO_LARGO_PROVEEDOR_OPERACION = 120;
/** Cantidad máxima de teléfonos vigentes que admite la ficha de un cliente. */
export const MAXIMO_TELEFONOS_CLIENTE = 5;
/** Unica moneda del sistema. Codigo ISO 4217. */
export const MONEDA = 'UYU';
/**
 * Exponente ISO 4217 del peso uruguayo: los importes se manejan como enteros en
 * centesimos (ADR-005). $800 se persiste y se opera como 80000.
 */
export const CENTESIMOS_POR_PESO = 100;
/** Tamano de la rejilla de la agenda, en minutos (ADR-007). */
export const MINUTOS_POR_SLOT = 30;
/** Cantidad de inicios validos que tiene un dia local: 24 * 60 / 30. */
export const SLOTS_POR_DIA = 48;
/** Duraciones de reserva ofrecidas, en minutos (ADR-007). */
export const DURACIONES_MINUTOS = [60, 90];
/** Identificadores de las dos canchas. Estables: aparecen en los ids de slot (ADR-008). */
export const CANCHAS = ['techada', 'exterior'];
//# sourceMappingURL=constantes.js.map